import React, { useEffect } from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import UseJoyride from './UseJoyride';

const DashboardJoyride = () => {
  return (
    <Observer
      render={() => {
        const DashSteps = [
          {
            target: '.dashStep1',
            content:
              'Notice the dashboard. This is where an all-encompassing view of your information lives.',
            disableBeacon: true,
          },
        ];
        return (
          <UseJoyride
            passedSteps={DashSteps}
            customProps={{ continuous: true, scrollOffset: 'auto' }}
          />
        );
      }}
    />
  );
};

export default DashboardJoyride;
